import React from 'react';
import { Link } from 'react-router-dom';

import style from './style.module.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

interface IconData {
  color: string;
  icon: React.ReactNode | false;
  title: string;
  link: string;
  href: string;
}

interface UsageData {
  title: string;
  title2: string;
  object: string;
  details: string;
  details2: string;
  percentage: number;
  color?: string;
}

interface SystemData {
  title: string;
  details: string;
  icon: React.ReactNode;
  color: string;
  percent: string;
}

interface CardProps {
  type: 'icon' | 'usage' | 'usage-alt' | 'system';
  chart?: 'red';
  iconData?: IconData;
  usageData?: UsageData;
  systemData?: SystemData;
}

const Card: React.FC<CardProps> = ({
  type,
  iconData = {
    color: 'blue',
    icon: false,
    title: 'title',
    link: '',
    href: '/'
  },
  usageData = {
    title: '',
    title2: '',
    object: '',
    details: '',
    details2: '',
    percentage: 0,
    color: 'default'
  },
  systemData = {
    title: 'API Server',
    details: 'Operational',
    icon: '',
    color: 'green',
    percent: '100%'
  },
  chart
}) => {


  const chartStyle = {
      red: style.red,
      default: style.default
  }[chart||'default'];

  const systemType = () => (
    <div className={`${style['system-type']} ${style[systemData.color]}`}>
      <div className={style.icon}>{systemData.icon}</div>
      <div className={style['details-title']}>
        <div className={style.title}>{systemData.title}</div>
        <div className={style.details}>{systemData.details}</div>
      </div>
      <div className={style.percent}>{systemData.percent}</div>
    </div>
  );

  const iconType = () => (
    <div className={`${style['icon-type']} ${style[iconData.color]}`}>
      <div className={style.icon}>{iconData.icon}</div>
      <div className={style.title}>{iconData.title}</div>
      <div className={style.link}>
        <Link to={iconData.href} className={style.linkText}>{iconData.link}</Link>
        <span><FontAwesomeIcon icon={faArrowRight} /></span>
      </div>
    </div>
  );

  const usageType = (alt = false) => (
    <div className={`${style['usage-type']} ${alt ? style.alt : ''}`}>
      <div className={style.title}>{usageData.title}</div>

      {!alt ? (
        <>
          <div className={style.object}>{usageData.object}</div>
          <div className={style.details}>{usageData.details}</div>
        </>
      ) : (
        <>
          <div className={style['details-left']}>
            <div className={style['details-1']}>{usageData.details}</div>
            <div className={style['title-2']}>{usageData.title2}</div>
            <div className={style['details-2']}>{usageData.details2}</div>
          </div>
          <div className={style['details-right']}>
            <div className={style.object}>{usageData.object}</div>
          </div>
        </>
      )}
      <div className={style.chart}>
        <div
          className={`${style.completed} ${chartStyle}`}
          style={{ width: `${usageData.percentage}%` }}
        ></div>
      </div>
    </div>
  );

  const renderCard = () => {
    switch (type) {
      case 'icon':
        return iconType();
      case 'usage':
        return usageType();
      case 'usage-alt':
        return usageType(true);
      case 'system':
        return systemType();
      default:
        return null;
    }
  };

  return (
    <div className={`${style.cards} ${type === 'usage-alt' ? style.full : ''} ${type === 'usage' ? style.usage_type : ''} ${style[iconData.icon ? iconData.color : (usageData.color || 'default')]}`}>
      {renderCard()}
    </div>
  );
};

export default Card;